import './journeyStage.css';

const JourneyStageSkeleton = () => {
    return (
        <div className="journey-stage-skeleton-card">
            <div className="journey-stage-skeleton-left">
                <div className="journey-stage-skeleton-title"></div>
                <div className="journey-stage-skeleton-subtitle"></div>
                <div className="journey-stage-skeleton-paragraph"></div>
                <div className="journey-stage-skeleton-paragraph short"></div>
                <div className="journey-stage-skeleton-paragraph"></div>
            </div>
            <div className="journey-stage-skeleton-right">
                <div className="journey-stage-skeleton-circle"></div>
            </div>
        </div>
    );
};

export default JourneyStageSkeleton;